import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import "./IncidentList.scss";
import { Button, Form, OverlayTrigger, Table, Badge, Dropdown } from "react-bootstrap";
import { BiDotsHorizontalRounded, BiDownload, BiPencil, BiSearch } from "react-icons/bi";
import { Link } from "react-router-dom";
import { CgSortAz } from "react-icons/cg";
import { DEFAULT_ITEMS_PER_PAGE, INCIDENTSTATUS, RISKSTATUS, STATUS } from "../../../core/constants/common";
import IncidentListService from "../../../core/service/IncidentListService";
import Utils from "../../../core/utilities/Utils";
import nodataimg from "../../../images/nodatafound.png";
import Pagination from "../../../components/Pagination/Pagination";
import { withTranslation } from "react-i18next";
import TruncatedText from "../../../core/utilities/TruncatedText";
import { FcFinePrint } from "react-icons/fc";
import { CompanyContext } from "../../../App";
import Multiselect from 'multiselect-react-dropdown';
import IncidentReportService from "../../../core/service/IncidentReportService";

const IncidentList = ({ t, detailedView = true, externalFilter }) => {
  const navigate = useNavigate();
  const [key, setKey] = useState("");
  const [maintablelist, setMainTableList] = useState([]);
  const [itemsTotalCount, setItemTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);
  const [currentPage, setCurrentPage] = useState(1);
  const { glbCompany } = useContext(CompanyContext);
  let encodedDat = Utils.encodeBase64(JSON.stringify(0));
  const glbCompanyId = glbCompany?.companyId ?? 0;
  const [statusKey, setStatusKey] = useState([]);
  const [priority, setPriority] = useState([]);
  const [typeId, setTypeId] = useState([]);
const [incidentType, setIncidentType] = useState([])
  const [companyNameId, setCompanyNameId] = useState([]);
  const [assigneeId, setAssigneeId] = useState("");
  const [reportedCompanyId, setReportedCompanyId] = useState([]);
  const [selectedAssigneeValues, setSelectedAssigneeValues] = useState([]);
  const [selectedCompanyValues, setSelectedCompanyValues] = useState([]);
  const [assignee, setAssignee] = useState([]);
  const [reporter, setReporter] = useState([]);
  const [companyName, setCompanyName] = useState([]);
  const [selectedOptionsAssignee, setSelectedOptionsAssignee] = useState([]);
  const [selectedOptionsCompany, setSelectedOptionsCompany] = useState([]);
  const [selectedOptionsStatus, setSelectedOptionsStatus] = useState([]);
  const [selectedOptionsPriority, setSelectedOptionsPriority] = useState([]);
  const [selectedOptionsType, setSelectedOptionsType] = useState([]);
  const [selectedOptionsReporter, setSelectedOptionsReporter] = useState([]);
  const [Key, setRefreshKey] = useState(0);


  const statusOptions = [
    { value: 'NEW', label: 'New' },
    { value: 'UNDER_INVESTIGATION', label: 'Under Investigation' },
    { value: 'CLOSED', label: 'Closed' },
    { value: 'ACCEPTED', label: 'Accepted' },
    { value: 'REJECTED', label: 'Rejected' }
  ]
  const priorityOptions = [
    { value: '0', label: 'Low' },
    { value: '1', label: 'Medium' },
    { value: '2', label: 'High' },
    ]

    
  useEffect(() => {
    getIncidentType();
    getMainTableList(0, itemsPerPage, key, statusKey, assigneeId, priority, reportedCompanyId, companyNameId,typeId);
    getSuggestionList(0, itemsTotalCount, key, statusKey, assigneeId, priority, reportedCompanyId, companyNameId,typeId);
  }, [externalFilter, glbCompanyId]);
  
  const getMainTableList = (pageNumber, itemsPerPageVal, key, statusKey, assigneeId, priority, reportedCompanyId, companyNameId,typeId) => {

    if (pageNumber > 0) {
      pageNumber = pageNumber - 1;
    } else {
      setCurrentPage(1);
    }
    if (itemsPerPageVal > 0) {
      var perPage = itemsPerPageVal;
    } else {
      var perPage = itemsPerPage;
    }
    // var sort = sortField + "," + order;
    // const commaSeparatedString = assigneeId.join(', ');

    IncidentListService.getList(
      pageNumber,
      perPage,
      statusKey,
      assigneeId,
      priority,
      reportedCompanyId,
      companyNameId,
      typeId,
      key,
      glbCompanyId,
    )
      .then((response) => {
        var totalPages = parseFloat(response.headers["x-total-count"]);
        setItemTotalCount(totalPages);
        setMainTableList([...response.data]);
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
        console.log("err", error);
      });
  };
  const editIncident = (item) => {
    const encodedDat = Utils.encodeBase64(JSON.stringify({ id: item.id, code: item.code }));
    navigate("/company_admin/report_incident?data=" + encodedDat);
  };
  const handleIncident = (item) => {
    let obj = { id: item.id, code: item.code };
    let encodedDat = Utils.encodeBase64(JSON.stringify(obj));
    navigate("/company_admin/incident/" + encodedDat);
  };
 

  const onSelectAssignee = (selectedList, selectedItem) => {
    const updatedAssigneeId = selectedList.reduce((acc, item) => {
      acc.push(item.value);
      return acc;
    }, []);
    setAssigneeId(updatedAssigneeId);
    setSelectedOptionsAssignee(selectedList);
    setSelectedAssigneeValues(selectedList.map((item) => item.value));
  };

  const onRemoveAssignee = (selectedList, removedItem) => {
    const updatedAssigneeId = selectedList.reduce((acc, item) => {
      acc.push(item.value);
      return acc;
    }, []);
    setAssigneeId(updatedAssigneeId);
    setSelectedOptionsAssignee(selectedList);
    setSelectedAssigneeValues(selectedList.map((item) => item.value));
  };
 
  const handleSelectCompany = (selectedList) => {
    setSelectedOptionsCompany(selectedList);
    setCompanyNameId(selectedList.map((item) => item.value));
  };
  const handleRemoveCompany = (selectedList) => {
    setSelectedOptionsCompany(selectedList);
    setCompanyNameId(selectedList.map((item) => item.value));
  };
  const handleSelectStatus = (selectedList) => {
    setSelectedOptionsStatus(selectedList);
    setStatusKey(selectedList.map((item) => item.value));
    };
  const handleRemoveStatus = (selectedList) => {
    setSelectedOptionsStatus(selectedList);
    setStatusKey(selectedList.map((item) => item.value));
    };
  const handleSelectPriority = (selectedList) => {
    setSelectedOptionsPriority(selectedList);
    setPriority(selectedList.map((item) => item.value));
    };
  const handleRemovePriority = (selectedList) => {
    setSelectedOptionsPriority(selectedList);
    setPriority(selectedList.map((item) => item.value));
    };
  const handleSelectType = (selectedList) => {
    setSelectedOptionsType(selectedList);
    setTypeId(selectedList.map((item) => item.id));
  };
  const handleRemoveType = (selectedList) => {
    setSelectedOptionsType(selectedList);
    setTypeId(selectedList.map((item) => item.id));
  };
  const handleSelectReporter = (selectedList) => {
    setSelectedOptionsReporter(selectedList);
    setReportedCompanyId(selectedList.map((item) => item.value));
  };
  const handleRemoveReporter = (selectedList) => {
    setSelectedOptionsReporter(selectedList);
    setReportedCompanyId(selectedList.map((item) => item.value));
  };
  
  const resetFilter = () => {
    setTypeId([]);
    setCompanyNameId([]);
    setReportedCompanyId([]);
    setPriority([]);
    setAssigneeId([]);
    setStatusKey([]);
    setSelectedOptionsAssignee([]);
    setSelectedOptionsCompany([]);
    setSelectedOptionsPriority([]);
    setSelectedOptionsStatus([]);
    setSelectedOptionsType([]);
    setSelectedOptionsReporter([]);
    getIncidentType();
    setRefreshKey((prevKey) => prevKey + 1);
    getSuggestionList(0, itemsPerPage, key)
    getMainTableList(0, itemsPerPage, key);
  }
const getIncidentType = () => {
  IncidentReportService.getIncidentTypeList().then((response)=>{
    setIncidentType(response.data);
     });
}
const getSuggestionList = (pageNumber, itemsPerPageVal, key, statusKey, assigneeId, priority, reportedCompanyId, companyNameId,typeId) => {
let perPage;
  if (pageNumber > 0) {
    pageNumber = pageNumber - 1;
  } else {
    setCurrentPage(1);
  }
  if (itemsPerPageVal > 0) {
     perPage = itemsPerPageVal;
  } else {
    perPage = itemsPerPage;
  }
  // var sort = sortField + "," + order;

  IncidentListService.getList(
    pageNumber,
    perPage,
    statusKey,
    assigneeId,
    priority,
    reportedCompanyId,
    companyNameId,
    typeId,
    key,
    glbCompanyId,
  )
    .then((response) => {
      var totalPages = parseFloat(response.headers["x-total-count"]);
      setItemTotalCount(totalPages);
      // setMainTableList([...response.data]);
      for (let index = 0; index < response.data.length; index++) {
        const element = response.data[index];
        assignee.push({
          name: element.assignee.fullName,
          value: element.assignee.id
        });
        reporter.push({
          name: element.reportedCompany.name,
          value: element.reportedCompany.id
        });
        companyName.push({
          name: element.owner.name,
          value: element.owner.id
        });
      }
      const uniqueArray = reporter.filter(
        (item, index) => index === reporter.findIndex(obj => JSON.stringify(obj) === JSON.stringify(item))
      );
      setReporter(uniqueArray);
      const uniqueArrayAssignee = assignee.filter(
        (item, index) => index === assignee.findIndex(obj => JSON.stringify(obj) === JSON.stringify(item))
      );
      setAssignee(uniqueArrayAssignee);
      const uniqueArrayCompany = companyName.filter(
        (item, index) => index === companyName.findIndex(obj => JSON.stringify(obj) === JSON.stringify(item))
      );
      setCompanyName(uniqueArrayCompany);
    })
    .catch((error) => {
      //ErrorHandlingService.handleError(error.response.status);
      console.log("err", error);
    });
};

  return (
    <div className="IncidentList">
      {detailedView && <div className="List_header">
        <h5 className="MH">{t("Incidents.label")}</h5>
        <div className="List_sorts_menu">
          <ul>
            <li>
              <Link to={`/company_admin/report_incident`}>
                <Button variant="primary">
                  {t("ReportIncident.label")}
                </Button>
              </Link>
            </li>
          </ul>
        </div>
      </div>}
      <div className="List_Table_01 mt-2">
        {detailedView && <div className="List_table-card01_head">
          <div className="List_table-card_Search_01">
            <div className="List_table-card_Search_Box">
              <Form>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={key}
                  placeholder="Search by Incidents"
                // onChange={handleSearch}
                />
                <Link to="#" className="Search_iocnBox">
                  <BiSearch />
                </Link>
              </Form>
            </div>
          </div>
          <div className="filter">
            <Link to="#" ><Dropdown className="filter_design" autoClose={false}>
              <Dropdown.Toggle className="btn btn-secondary">
                <CgSortAz  className="FilterIcon"/>{t("Filter.label")}
              </Dropdown.Toggle>
              <Dropdown.Menu className="filter-dropdown-menu">
                <div className="px-2">
                  <div className="pb-2">
                    <label>Incident Type</label>
                     <Multiselect
                      options={incidentType}
                      selectedValues={selectedOptionsType}
                      onSelect={handleSelectType}
                      onRemove={handleRemoveType}
                      displayValue="name"
                      key={Key}
                    />
                  </div>
                  <div className="pb-2">
                    <label>Status</label>
                    <Multiselect
                      options={statusOptions}
                      selectedValues={selectedOptionsStatus}
                      onSelect={handleSelectStatus}
                      onRemove={handleRemoveStatus}
                      displayValue="label"
                      key={Key}
                    />
                  </div>
                  <div className="pb-2">
                    <label>Priority</label>
                    <Multiselect
                      options={priorityOptions}
                      selectedValues={selectedOptionsPriority}
                      onSelect={handleSelectPriority}
                      onRemove={handleRemovePriority}
                      displayValue="label"
                      key={Key}
                    />
                  </div>
                  <div className="pb-2">
                    <label>Reporter</label>
                    <Multiselect
                      options={reporter}
                      selectedValues={selectedOptionsReporter}
                      onSelect={handleSelectReporter}
                      onRemove={handleRemoveReporter}
                      displayValue="name"
                    />
                  </div>
                  <div className="pb-2">
                    <label>Assignee</label>
                    <Multiselect
                      options={assignee}
                      selectedValues={selectedOptionsAssignee}
                      onSelect={onSelectAssignee}
                      onRemove={onRemoveAssignee}
                      displayValue="name"
                    />
                  </div>
                  <div className="pb-2">
                    <label>Company Name</label>
                    <Multiselect
                      options={companyName}
                      selectedValues={selectedOptionsCompany}
                      onSelect={handleSelectCompany}
                      onRemove={handleRemoveCompany}
                      displayValue="name"
                    />
                  </div>
                  <div className="text-center">
                    <button className="btn btn-primary" onClick={() => getMainTableList(0, itemsPerPage, key, statusKey, assigneeId, priority, reportedCompanyId, companyNameId,typeId)}>Apply</button>
                    <button className="btn btn-secondary ms-2" onClick={() => resetFilter()}>Reset</button>
                  </div>
                </div>
              </Dropdown.Menu>

            </Dropdown>

            </Link>


          </div>
          {/* <div className="List_table-card01_sort">
            <ul>
              <li className="filter">
                <Link to="#">
                  <CgSortAz /> {t("Filter.label")}
                </Link>
              </li>
            </ul>
          </div> */}
        </div>}
        <div className={detailedView ? 'card List_table-card01' : 'List_table-card01'}>
          <Table responsive="sm">
            <thead>
              <tr>
                {/* <th className="th_check">
                  <Form.Check
                    inline
                    name="group1"
                    type="checkbox"
                    id="inline-checkbox-1"
                  />
                </th> */}
                <th>{t("ReferenceNo.label")}.</th>
                {detailedView && <th>
                  <Link to="#">
                    {t("Title.label")}
                    {/* <BiSort /> */}
                  </Link>
                </th>}
                <th>
                  <Link to="#">
                    {t("IncidentType.label")}
                    {/* <BiSort /> */}
                  </Link>{" "}
                </th>
                {detailedView && <th>{t("Reporter.label")}</th>}
                <th>{t("Reportedon.label")}</th>
                <th>
                  <Link to="#">
                    {t("Status.label")}
                    {/* <BiSort /> */}
                  </Link>{" "}
                </th>
                <th>{t("Priority.label")}</th>
                {detailedView && <th>{t("Assignee.label")}</th>}
                {detailedView && <th>{t("CompanyName.label")}</th>}
                {detailedView && <th></th>}
              </tr>
            </thead>
            <tbody>
              {maintablelist.length > 0 ? (
                maintablelist?.map((item) => (
                  <tr key={item.id}>
                    {/* <td className="checkbox">
                      {" "}
                      <Form.Check
                        inline
                        name="group1"
                        type="checkbox"
                        id="inline-checkbox-1"
                      />
                    </td> */}
                    <td>
                      <span
                        onClick={() => handleIncident(item)}
                        className="text-blue cursor"
                      >
                        {item.code}
                      </span>
                    </td>
                    {detailedView && <td><TruncatedText text={item.title}></TruncatedText></td>}
                    <td>{item?.incidentType?.name}</td>
                    {detailedView && <td>{item?.reportedCompany?.name}</td>}
                    <td>{moment(item?.createdDate).format("MMM DD, YYYY")}</td>
                    <td>
                      {(() => {
                        switch (item.status) {
                          case "NEW":
                            return (
                              <Badge bg="badge-New">
                                {STATUS[item.status]}
                              </Badge>
                            );
                          case "ACCEPTED":
                            return (
                              <Badge bg="badge-Accepted">
                                {STATUS[item.status]}
                              </Badge>
                            );
                          case "REJECTED":
                            return (
                              <Badge bg="badge-Rejected">
                                {STATUS[item.status]}
                              </Badge>
                            );
                          case "UNDER_INVESTIGATION":
                            return (
                              <Badge bg="badge-Underinvestigation">
                                {STATUS[item.status]}
                              </Badge>
                            );
                          case "CLOSED":
                            return (
                              <Badge bg="badge-Closed">
                                {STATUS[item.status]}
                              </Badge>
                            );
                          default:
                            return " ";
                        }
                      })()}
                    </td>
                    <td>
                      {(() => {
                        switch (item.priority) {
                          case "LOW":
                            return (
                              <Badge bg="badge-Low">{t("Low.label")}</Badge>
                            );

                          case "HIGH":
                            return (
                              <Badge bg="badge-High">{t("High.label")}</Badge>
                            );
                          case "MEDIUM":
                            return (
                              <Badge bg="badge-Medium">{t("Medium.label")}</Badge>
                            );
                          default:
                            return " ";
                        }
                      })()}
                    </td>
                    {detailedView && <td>{item?.assignee?.fullName}</td>}
                    {detailedView && <td>{item?.owner?.name}</td>}

                    <td>
                      {
                        detailedView && item.status === "NEW" &&
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="blank_outline"
                            id="task-list-dropdown">
                            <BiDotsHorizontalRounded />
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {
                              item.status !== "CLOSED"
                                ?
                                <Dropdown.Item onClick={() => editIncident(item)}>
                                  {t("Edit.label")}
                                </Dropdown.Item>
                                : <></>
                            }
                            <Dropdown.Item onClick={() => handleIncident(item)}>
                              {t("View.label")}
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      }

                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" className="text-center">
                    <div className="Nodatafound_box">
                      <h6><FcFinePrint className="me-2" /> {t("Nodatafound.label")}</h6>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          {(detailedView || itemsTotalCount > 10) && <div className="p-2 List_footer_count">
            <Pagination
              itemsTotalCount={itemsTotalCount}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              alwaysShown={true}
              setItemsPerPage={setItemsPerPage}
              pageClicked={(pageNum, perPage) => {
                getMainTableList(pageNum, perPage, key, statusKey, assigneeId, priority, reportedCompanyId, companyNameId,typeId);
              }}
            />
          </div>}
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(IncidentList);
